import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    position: 'relative',
    width: '100%',
  },
  moduleHeader: {
    margin: `${pxToRem(18)} ${pxToRem(24)} ${pxToRem(32)}`,
    borderBottom: `${pxToRem(2)} solid ${theme.palette.neutralTertiaryAlt}`,
  },
  moduleContent: {
    padding: `0 ${pxToRem(24)} ${pxToRem(32)} ${pxToRem(24)}`,
  },
  moduleIndentedContent: {
    display: 'block',
    paddingLeft: pxToRem(16),
    paddingRight: pxToRem(16),
  },
  statementPortalText: {
    fontSize: pxToRem(12),
    lineHeight: pxToRem(16),
    fontWeight: 400,
    color: theme.palette.neutralSecondary,
  },
  infoMessage: {
    display: 'flex',
    alignItems: 'flex-start',
    color: theme.palette.neutralSecondary,
    paddingTop: pxToRem(10),
  },
  infoIcon: {
    position: 'relative',
    marginRight: pxToRem(6),
    color: theme.palette.neutralTertiary,
  },
  infoText: {
    fontSize: pxToRem(12),
    lineHeight: pxToRem(16),
    fontWeight: 400,
  },
  iframeContainer: {
    position: 'relative',
    overflow: 'hidden',
    paddingTop: '56.25%',
  },
  iframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
  fullWidthLimit: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    maxWidth: pxToRem(1204),
    margin: '0 auto',
  },
});
